import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useDrag, useDrop } from "react-dnd";
import { addCustomerForm, loadCustomerForm } from "../../api/ajustesApi";
import { useNotification } from "../../context/NotificationContext";

const CustomerForm = () => {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("lgusr"));
  const isAdmin = user?.role === "ADMIN";
  const org_id = user?.orgId;

  const [fields, setFields] = useState([
    label => "",
    type => "text",
    required => false,
    defaultValue => "",
    minLength => 0,
    maxLength => 255,
    options => [],
    hasApi => false,
    showInList => false,
    uniqueProp => false,
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editField, setEditField] = useState(null);

  const [newField, setNewField] = useState({});
  const [errors, setErrors] = useState({});
  const notify = useNotification();

  useEffect(() => {
    setFields([]);
    fetchCustomerForm();
  }, []);

  const fetchCustomerForm = async () => {
    try {
      const response = await loadCustomerForm();
      console.log(response);
      setFields(response.json || []);
    }
    catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const addField = () => {
    const camelCaseRegex = /^[a-z][a-zA-Z]*$/;

    if (!camelCaseRegex.test(newField.label)) {
      notify("error", "Field Name must be in camelCase and contain only letters.")
      return;
    }
    if (typeof newField.label !== "string" || newField.label.length < 2 || newField.label.length > 20) {
      notify("error", "Field label must be between 2 and 20 characters.");
      return;
    }
    const isDuplicate = fields.some(field => field.label === newField.label);
    if (isDuplicate) {
      notify("error", "A field with this label already exists. Please use a different label.");
      return;
    }

    setFields([...fields, { ...newField }]);
    setNewField({
      label: "",
      type: "text",
      required: false,
      defaultValue: "",
      minLength: 0,
      maxLength: 255,
      options: [],
      hasApi: false,
      showInList: false,
      uniqueProp: false,
    });
  };

  const saveFormConfig = async (e) => {
    e.preventDefault();
    const payload = {
      organizationId: org_id,
      formData: fields,
    };
    console.log(payload);

    if (payload.formData == null) {
      notify("error", "Add Least one field!");
      return;
    }

    try {
      const response = await addCustomerForm(payload);
      setFields([]);
      notify("success", "Dynamic Form Updated");

    } catch (error) {
      notify("error", "error");
      console.log('Error submitting form:', error.getMessage());
    }
  };

  const toggleFieldProperty = (index, property) => {
    setFields((prevFields) => {
      const updatedFields = prevFields.map((field, i) => {
        if (i === index) {
          return {
            ...field,
            [property]: !field[property],
          };
        }
        return field;
      });
      return updatedFields;
    });
  };

  const removeField = (index) => {
    console.log(fields);
    setFields(fields.filter((_, i) => i !== index));
  };

  const moveField = (dragIndex, hoverIndex) => {
    const updatedFields = [...fields];
    const [draggedField] = updatedFields.splice(dragIndex, 1);
    updatedFields.splice(hoverIndex, 0, draggedField);
    setFields(updatedFields);
  };

  const Field = ({ field, index }) => {
    const [, drag] = useDrag(() => ({
      type: "FIELD",
      item: { index },
    }));

    const [, drop] = useDrop(() => ({
      accept: "FIELD",
      hover: (item) => {
        if (item.index !== index) {
          moveField(item.index, index);
          item.index = index;
        }
      },
    }));

    return (
      <tr
        ref={(node) => drag(drop(node))}
        key={index}
        className="bg-white hover:bg-blue-50"
      >
        <td className="border border-blue-300 px-4 py-2 truncate" title={field.label}>
          {field.label}
        </td>
        <td className="border border-blue-300 px-4 py-2">{field.type}</td>
        <td className="border border-blue-300 px-4 py-2 text-center">
          {field.required ? <span className="text-orange-600">Yes</span> : "No"}
          <button
            className="text-blue-600 hover:text-blue-800 mx-2"
            title="Toggle Required"
            onClick={() => toggleFieldProperty(index, "required")}
          >
            <i className={`fas ${field.required ? "fa-toggle-on" : "fa-toggle-off"}`}></i>
          </button>
        </td>
        <td className="border border-blue-300 px-4 py-2 text-center">
          {/* Show Min/Max/Options */}
          <div className="text-center">
            {field.type === "checkbox" || field.type === "dropdown" ? (
              <div className="text-sm text-blue-700">
                {field.options.length > 0
                  ? field.options.join(", ")
                  : "No options defined"}
              </div>
            ) : (
              <div className="text-sm text-blue-700">
                {field.minLength > 0 ? `Min: ${field.minLength}` : ""}{" "}
                {field.maxLength > 0 ? `Max: ${field.maxLength}` : ""}
              </div>
            )}
          </div>
        </td>
        <td className="border border-blue-300 px-4 py-2 text-center">
          <div className="text-center">
            {field.type == "text" ? (
              <>
                {field.uniqueProp ? <span className="text-orange-600">Yes</span> : "No"}
                <button
                  className="text-blue-600 hover:text-blue-800 mx-2"
                  title="Toggle Required"
                  onClick={() => toggleFieldProperty(index, "uniqueProp")}
                >
                  <i className={`fas ${field.uniqueProp ? "fa-toggle-on" : "fa-toggle-off"}`}></i>
                </button>
              </>
            ) : ("-")}
          </div>
        </td>
        <td className="border border-blue-300 px-4 py-2 text-center">
          <div className="text-center">
            {field.showInList ? <span className="text-orange-600">Yes</span> : "No"}
            <button
              className="text-blue-600 hover:text-blue-800 mx-2"
              title="Toggle Required"
              onClick={() => toggleFieldProperty(index, "showInList")}
            >
              <i className={`fas ${field.showInList ? "fa-toggle-on" : "fa-toggle-off"}`}></i>
            </button>
          </div>
        </td>
        <td className="border border-blue-300 px-4 py-2 text-center">
          <div className="text-center">
            {field.type == "text" ? (
              <>
                {field.hasApi ? <span className="text-orange-600">Yes</span> : "No"}
                <button
                  className="text-blue-600 hover:text-blue-800 mx-2"
                  title="Toggle Required"
                  onClick={() => toggleFieldProperty(index, "hasApi")}
                >
                  <i className={`fas ${field.hasApi ? "fa-toggle-on" : "fa-toggle-off"}`}></i>
                </button>
              </>
            ) : ("-")}
          </div>
        </td>
        <td className="border border-blue-300 px-4 py-2 text-center">
          {/* Active icon */}
          <div className="flex justify-center items-center">
            <button
              type="button"
              className="text-green-600 hover:text-green-800"
              title="Edit Field"
              onClick={(e) => {
                e.stopPropagation(); // Stop event propagation
                setEditField({ ...field }); // Populate the modal with the field's data
                setIsModalOpen(true); // Open the modal
              }}
            >
              <i className="fas fa-edit"></i>
            </button>
            <button
              className="text-orange-600 hover:text-orange-800 mx-2"
              title="Remove Field"
              onClick={(e) => {
                e.stopPropagation();
                removeField(index);
              }}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="flex items-center justify-center bg-blue-50 min-h-screen">
      <div className="p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold text-center text-blue-600 mb-6">
          Customer Form Builder
        </h1>
        <div className="border border-blue-200 p-4 mb-6 bg-blue-50 rounded-lg">
          <div>
            <h2 className="block text-lg font-semibold text-orange-600 mb-2">
              Add New Field
            </h2>
            <div>
              <label className="block text-blue-700 mb-1">
                Field Name
              </label>
              <input
                type="text"
                placeholder="Field Label"
                value={newField.label}
                onChange={(e) =>
                  setNewField({
                    ...newField,
                    label: e.target.value,
                  })
                }
                className="border border-blue-300 p-2 rounded w-full mb-4 focus:ring focus:ring-blue-200"
              />
            </div>
          </div>
          <div>
            <label className="block text-blue-700 mb-1">
              Field Type
            </label>
            <select
              value={newField.type}
              onChange={(e) =>
                setNewField({
                  ...newField,
                  type: e.target.value,
                })
              }
              className="border border-blue-300 p-2 rounded w-full mb-4 focus:ring focus:ring-blue-200"
            >
              <option>Select input type</option>
              <option value="text">Text</option>
              <option value="textarea">Text Area</option>
              <option value="number">Number</option>
              <option value="date">Date</option>
              <option value="checkbox">Checkbox</option>
              <option value="dropdown">Dropdown</option>
              <option value="date">Date</option>
              <option value="time">Time</option>
              <option value="datetime">DateTime</option>
              <option value="email">Email</option>
            </select>
          </div>

          <label className="flex items-center space-x-2 mb-4">
            <input
              type="checkbox"
              checked={newField.required}
              onChange={(e) =>
                setNewField({
                  ...newField,
                  required: e.target.checked,
                })
              }
              className="w-4 h-4 text-blue-600 focus:ring focus:ring-blue-200"
            />
            <span className="text-blue-700">Required</span>
          </label>
          {(newField.type === "checkbox" || newField.type === "dropdown") && (
            <div>
              <label className="block text-blue-700 mb-1">
                Options (comma-separated)
              </label>
              <input
                type="text"
                placeholder="Option 1, Option 2, Option 3"
                value={newField.options ? newField.options.join(", ") : ""}
                onChange={(e) => {
                  const options = e.target.value
                    .split(",")
                    .map((option) => option.trim());
                  setNewField({
                    ...newField,
                    options: options,
                  });
                }}
                className="border border-blue-300 p-2 rounded w-full mb-4 focus:ring focus:ring-blue-200"
              />
            </div>
          )}

          {newField.type === "text" || newField.type === "textarea" ? (
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-blue-700 mb-1">
                  Min
                </label>
                <input
                  type="number"
                  placeholder="Min Length"
                  value={newField.minLength}
                  onChange={(e) =>
                    setNewField({
                      ...newField,
                      minLength:
                        parseInt(e.target.value) ||
                        0,
                    })
                  }
                  className="border p-2 rounded w-full"
                />
              </div>
              <div>
                <label className="block text-blue-700 mb-1">
                  Max
                </label>
                <input
                  type="number"
                  placeholder="Max Length"
                  value={newField.maxLength}
                  onChange={(e) =>
                    setNewField({
                      ...newField,
                      maxLength: parseInt(e.target.value) || 0,
                    })
                  }
                  className="border p-2 rounded w-full"
                />
              </div>
              <div>
                <label className="flex items-center space-x-2 mb-4">
                  <input
                    type="checkbox"
                    checked={newField.uniqueProp}
                    onChange={(e) =>
                      setNewField({
                        ...newField,
                        uniqueProp: e.target.checked,
                      })
                    }
                    className="w-4 h-4 text-blue-600 focus:ring focus:ring-blue-200"
                  />
                  <span className="text-blue-700">Is Unique</span>
                </label>
              </div>
              <div>
                <label className="flex items-center space-x-2 mb-4">
                  <input
                    type="checkbox"
                    checked={newField.hasApi}
                    onChange={(e) =>
                      setNewField({
                        ...newField,
                        hasApi: e.target.checked,
                      })
                    }
                    className="w-4 h-4 text-blue-600 focus:ring focus:ring-blue-200"
                  />
                  <span className="text-blue-700">Has External API</span>
                </label>
              </div>
            </div>
          ) : (
            ""
          )}
          {newField.type === "time" ? (
            <div>
              <label className="block text-blue-700 mb-1">Time</label>
              <input
                type="time"
                value={newField.time || ""}
                onChange={(e) => {
                  setNewField({
                    ...newField,
                    time: e.target.value,
                  });
                }}
                className="border border-blue-300 p-2 rounded w-full mb-4 focus:ring focus:ring-blue-200"
              />
            </div>
          ) : ""}
          {newField.type === "date" ? (
            <div>
              <label className="block text-blue-700 mb-1">Date</label>
              <input
                type="date"
                value={newField.date || ""}
                onChange={(e) => {
                  setNewField({
                    ...newField,
                    date: e.target.value,
                  });
                }}
                className="border border-blue-300 p-2 rounded w-full mb-4 focus:ring focus:ring-blue-200"
              />
            </div>
          ) : ""}
          {newField.type === "datetime" ? (
            <div>
              <label className="block text-blue-700 mb-1">Date and Time</label>
              <input
                type="datetime-local"
                value={newField.datetime || ""}
                onChange={(e) => {
                  setNewField({
                    ...newField,
                    datetime: e.target.value,
                  });
                }}
                className="border border-blue-300 p-2 rounded w-full mb-4 focus:ring focus:ring-blue-200"
              />
            </div>
          ) : null}

          <div>
            <label className="flex items-center space-x-2 mb-4">
              <input
                type="checkbox"
                checked={newField.showInList}
                onChange={(e) =>
                  setNewField({
                    ...newField,
                    showInList: e.target.checked,
                  })
                }
                className="w-4 h-4 text-blue-600 focus:ring focus:ring-blue-200"
              />
              <span className="text-blue-700">Show In List</span>
            </label>
          </div>

          <button
            className="w-full bg-orange-600 text-white py-2 rounded hover:bg-orange-700"
            onClick={addField}
          >
            Add Field
          </button>
        </div>
        <div className="border border-blue-200 p-4 mb-6 bg-blue-50 rounded-lg">
          <form onSubmit={saveFormConfig} className="overflow-visible">
            <table className="min-w-full table-auto mt-6">
              <thead>
                <tr>
                  <th className="border border-blue-300 px-4 py-2">Field Name</th>
                  <th className="border border-blue-300 px-4 py-2">Type</th>
                  <th className="border border-blue-300 px-4 py-2">Required</th>
                  <th className="border border-blue-300 px-4 py-2">Min/Max/Options</th>
                  <th className="border border-blue-300 px-4 py-2">Unique</th>
                  <th className="border border-blue-300 px-4 py-2">Show</th>
                  <th className="border border-blue-300 px-4 py-2">Api</th>
                  <th className="border border-blue-300 px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, index) => (
                  <Field key={index} field={field} index={index} />
                ))}
              </tbody>
            </table>

            <button type="submit" className="mt-6 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
              Save Form
            </button>
          </form>
        </div>
      </div>
      {/* Render Modal if Open */}
      {isModalOpen && <Modal />}
    </div>
  );

  // Modal Component
  function Modal() {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-[90vw] max-w-md">
          <h2 className="text-xl font-semibold text-blue-600 mb-4">Edit Field</h2>
          <form 
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className="space-y-4"
          >
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Field Label
              </label>
              <input
                type="text"
                value={editField?.label || ""}
                onChange={(e) =>
                  setEditField({ ...editField, label: e.target.value })
                }
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                placeholder="Enter field label"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Field Type
              </label>
              <select
                value={editField?.type || "text"}
                onChange={(e) =>
                  setEditField({ ...editField, type: e.target.value })
                }
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
              >
                <option value="text">Text</option>
                <option value="number">Number</option>
                <option value="checkbox">Checkbox</option>
                <option value="dropdown">Dropdown</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Required
              </label>
              <input
                type="checkbox"
                checked={editField?.required || false}
                onChange={(e) =>
                  setEditField({ ...editField, required: e.target.checked })
                }
                className="mt-1"
              />
            </div>
            <div className="flex justify-end space-x-2">
              <button
                type="button"
                onClick={() => {
                  setIsModalOpen(false);
                  setEditField(null);
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={addField}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };
}

export default CustomerForm;